import { pushEvent } from '../../../client/data-layer';
import { Price } from '../../../types';

// Tracks when the user changes a filter for the offerlist
export const trackPriceListFilterUpdate = (
  selectedFilter: string,
  checked: boolean
) => {
  pushEvent('priceListFilterUpdate', { selectedFilter, checked });
};

export const trackProductCompareTopTenLinkClick = (productId: number) =>
  pushEvent('productCompareTopTenLinkClicked', { productId });

type ProductSizeVariantClickoutData = {
  isVariantFiltered: boolean;
  isPrimaryList: boolean;
};

export const trackProductSizeVariantClickout = (
  data: ProductSizeVariantClickoutData
) => {
  pushEvent('productSizeVariantClickout', data);
};

export type OurChoiceExperimentClickOutData = {
  price: Price;
  isOurChoice: boolean;
  position?: 'productHeader' | 'offerList';
  offerListPosition?: number;
};

export const trackOurChoiceExperimentClickOut = (
  data: OurChoiceExperimentClickOutData
) => pushEvent('ourChoiceExperimentClickOut', data);
